import { dateLib } from "@agentcall/core/lib"
import { type ZodErrorMap, z } from "zod"

export const customErrorMap: ZodErrorMap = (issue) => {
  // デフォルトメッセージを日本語に変換
  switch (issue.code) {
    case z.ZodIssueCode.invalid_type:
      if (issue.expected === "string") {
        return { message: "文字列を入力してください" }
      }
      if (issue.expected === "number") {
        return { message: "数値を入力してください" }
      }
      if (issue.expected === "boolean") {
        return { message: "真偽値を入力してください" }
      }
      if (issue.expected === "date") {
        return { message: "日付を入力してください" }
      }
      return { message: `${issue.expected}型の値を入力してください` }

    case z.ZodIssueCode.unrecognized_keys:
      return { message: `認識できないキー: ${(issue.keys ?? []).join(", ")}` }

    case z.ZodIssueCode.invalid_union:
      return { message: "入力値が無効です" }

    case z.ZodIssueCode.invalid_value:
      return { message: "有効な値を選択してください" }

    case z.ZodIssueCode.invalid_format:
      if (issue.validation === "email") {
        return { message: "有効なメールアドレスを入力してください" }
      }
      if (issue.validation === "url") {
        return { message: "有効なURLを入力してください" }
      }
      return { message: "入力形式が正しくありません" }

    case z.ZodIssueCode.too_small:
      if (issue.type === "array") {
        if (issue.minimum === 1) {
          return { message: "1つ以上選択してください" }
        }
        return { message: `${issue.minimum}個以上選択してください` }
      }
      if (issue.type === "string") {
        if (issue.minimum === 1) {
          return { message: "必須項目です" }
        }
        return { message: `${issue.minimum}文字以上入力してください` }
      }
      if (issue.type === "number") {
        if (issue.inclusive) {
          return { message: `${issue.minimum}以上の数値を入力してください` }
        }
        return { message: `${issue.minimum}より大きい数値を入力してください` }
      }
      if (issue.type === "date") {
        return {
          message: `${dateLib.formatDateLocale(new Date(issue.minimum as number))}以降の日付を入力してください`,
        }
      }
      if (issue.type === "set") {
        return { message: `${issue.minimum}個以上の要素が必要です` }
      }
      return { message: "値が小さすぎます" }

    case z.ZodIssueCode.too_big:
      if (issue.type === "array") {
        return { message: `${issue.maximum}個以下で選択してください` }
      }
      if (issue.type === "string") {
        return { message: `${issue.maximum}文字以下で入力してください` }
      }
      if (issue.type === "number") {
        if (issue.inclusive) {
          return { message: `${issue.maximum}以下の数値を入力してください` }
        }
        return { message: `${issue.maximum}未満の数値を入力してください` }
      }
      if (issue.type === "date") {
        return {
          message: `${dateLib.formatDateLocale(new Date(issue.maximum as number))}以前の日付を入力してください`,
        }
      }
      if (issue.type === "set") {
        return { message: `${issue.maximum}個以下の要素にしてください` }
      }
      return { message: "値が大きすぎます" }

    case z.ZodIssueCode.custom:
      return { message: issue.message || "入力値が無効です" }

    case z.ZodIssueCode.not_multiple_of:
      return { message: `${issue.multipleOf}の倍数を入力してください` }

    default:
      return { message: issue.message ?? "入力値が不正です" }
  }
}
